import { call, put, takeLatest } from 'redux-saga/effects';

import { BillingApi } from '@apis/BillingApi';
import { PaymentTransactionApi } from '@apis/PaymentTransactionApi';
import { Billing } from '@models/Billing';
import { PaymentTransaction } from '@models/PaymentTransaction';
import { SagaPayload } from '@utils/typescript';
import { CancerQuoteApi } from '@apis/CancerQuoteApi';
import { CancerQuote } from '@models/CancerQuote';

import {
  cancerQuoteFetch,
  CancerQuoteFetchPayload,
  billingFetch,
  BillingFetchPayload,
  paymentTransactionCreate,
  PaymentTransactionCreatePayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCancerQuoteFetch({ payload }: SagaPayload<CancerQuoteFetchPayload>) {
  const state: StateUpdatePayload = { cancerQuote: null };
  try {
    state.cancerQuote = (yield call(CancerQuoteApi.get, payload)) as CancerQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleBillingFetch({ payload }: SagaPayload<BillingFetchPayload>) {
  const state: StateUpdatePayload = { billing: null };
  try {
    state.billing = (yield call(BillingApi.get, payload)) as Billing;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePaymentTransactionCreate({ payload }: SagaPayload<PaymentTransactionCreatePayload>) {
  const state: StateUpdatePayload = { paymentTransaction: null };
  try {
    state.paymentTransaction = (yield call(PaymentTransactionApi.create, payload)) as PaymentTransaction;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(cancerQuoteFetch, handleCancerQuoteFetch);
  yield takeLatest(billingFetch, handleBillingFetch);
  yield takeLatest(paymentTransactionCreate, handlePaymentTransactionCreate);
}
